import { WSText } from "@wingspanhq/fe-component-library";
import { PayoutDestinationType } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { WSQueries } from "../query/WSQuery";
import { useQueryOwnPayoutSettings } from "@hooks/useQueryOwnPayoutSettings";
import { queriesExternalBankAccounts } from "@query";
import { selectorExternalBankAccountName } from "@selectors/selectorExternalBankAccountName";
import { LayoutPaymentsSetup } from "../shared/components/LayoutPaymentsSetup";

export const OnboarderComplete: React.FC = () => {
  const queryExternalBankAccounts =
    queriesExternalBankAccounts.listExternalBankAccounts.useQuery();
  const qPayoutSettings = useQueryOwnPayoutSettings();

  return (
    <LayoutPaymentsSetup>
      <WSQueries queries={{ queryExternalBankAccounts, qPayoutSettings }}>
        {({
          queryExternalBankAccounts: { data: externalBankAccountList },
          qPayoutSettings: { data: payoutSettings }
        }) => {
          const standardPayoutDestination = payoutSettings?.standardDestination;

          const payoutAccount = (externalBankAccountList.data || []).find(
            externalBankAccount =>
              externalBankAccount.id === standardPayoutDestination?.id
          );

          const giftcardPayoutDestination =
            payoutSettings?.standardDestination?.type ===
              PayoutDestinationType.GIFT_CARD ||
            payoutSettings?.instantDestination?.type ===
              PayoutDestinationType.GIFT_CARD;

          const depositAccountDetailsText = payoutAccount
            ? `Your payments will be deposited into your ${selectorExternalBankAccountName(
                payoutAccount
              )} account via direct deposit (ACH).`
            : giftcardPayoutDestination
              ? "You will receive payments as a gift card which will be delivered to your email address."
              : "Your payments will be deposited to your Wingspan Wallet.";

          return (
            <>
              <WSText.Heading4 mb="XS" data-testid="heading">
                You’re ready to receive payments
              </WSText.Heading4>

              <WSText mb="3XL">{depositAccountDetailsText}</WSText>
            </>
          );
        }}
      </WSQueries>
    </LayoutPaymentsSetup>
  );
};
